// extracted by mini-css-extract-plugin
export var infoRow = "_va-2";
export var labelContainer = "_va-0";
export var rightInfo = "_va-1";